import React from 'react';
import { ProductBrand, ProductBrandsResponse } from '../../types/schema';
import { Flex, Image, Skeleton } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from 'utils/messages';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import noImage from 'components/Image/noIMG.svg';
import Arrow from './arrow.svg';
import generateThumbnailImage from 'utils/generateThumbnailImage';

const BrandWrapper = styled(Link)`
  border-radius: 6px;
  background-color: #fff;
`;

const BrandColumn = styled.div`
  display: flex;
  gap: ${({ isMega }) => (isMega ? '40px' : '20px')};
  row-gap: ${({ isMega }) => (isMega ? '32px' : '20px')};
  min-width: 226px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: ${({ isMega }) => (isMega ? '20px 40px' : '20px')};
  border-radius: 0px 8px 8px 0px;
  margin-bottom: auto;
`;
const Brand = styled(Image)`
  &.ant-image-img {
    display: block;
    object-fit: contain;
    border-radius: 6px;
  }
`;

const ViewAllBrands = styled(Link)`
  color: #3c9041;
  text-align: right;
  font-family: 'SF Pro Text';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
  min-width: max-content;
  display: flex;
  align-items: center;
  gap: 4px;
  &:hover {
    opacity: 0.9;
    color: #3c9041;
    svg {
      opacity: 0.9;
    }
  }
`;

export interface BrandsByCategory extends Pick<ProductBrandsResponse, 'data'> {
  categoryId?: number;
}

interface BrandByCategoryProps {
  brands?: BrandsByCategory;
  loading?: boolean;
  isMega?: boolean;
}

const BrandByCategory: React.FC<BrandByCategoryProps> = ({ brands, loading = false, isMega }) => {
  const imageSize = isMega ? 100 : 80;
  if (loading) {
    return (
      <BrandColumn wrap gap={20}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton.Image key={index} style={{ width: 80, height: 80, borderRadius: 6 }} active />
        ))}
        <Skeleton.Input style={{ width: 100, height: 20, marginTop: 8 }} active />
      </BrandColumn>
    );
  }

  if (!brands?.data?.length) return null;
  return (
    <BrandColumn wrap isMega={isMega}>
      {brands?.data?.map((brand: ProductBrand) => {
        // how to check if it a url or not
        const isUrl = brand?.imageUrl && (brand?.imageUrl.includes('http') || brand?.imageUrl.includes('static/media'));
        return (
          <BrandWrapper to={`/thuong-hieu/${brand.slug}-b${brand.id}`} key={brand.id}>
            {isUrl ? (
              <Brand preview={false} width={imageSize} height={imageSize} key={brand?.id} src={generateThumbnailImage(brand?.imageUrl || '', imageSize)} />
            ) : (
              <SVGIcon src={noImage} width={imageSize} height={imageSize} />
            )}
          </BrandWrapper>
        );
      })}
      <ViewAllBrands to={brands?.categoryId ? `/thuong-hieu?categoryId=${brands?.categoryId}` : '/thuong-hieu'}>
        <FormattedMessage {...messages.viewAllBrands} />
        <SVGIcon src={Arrow} />
      </ViewAllBrands>
    </BrandColumn>
  );
};

export default BrandByCategory;
